import { render, staticRenderFns } from "./ReCare.vue?vue&type=template&id=3eec0d98&scoped=true"
import script from "./ReCare.vue?vue&type=script&lang=js"
export * from "./ReCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec0d98",
  null
  
)

export default component.exports